'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _posters = require('./posters.html');

var _posters2 = _interopRequireDefault(_posters);

var _banners = require('./banners.html');

var _banners2 = _interopRequireDefault(_banners);

var _rollUps = require('./roll-ups.html');

var _rollUps2 = _interopRequireDefault(_rollUps);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  posters: _posters2.default,
  banners: _banners2.default,
  "roll-ups": _rollUps2.default

  // WEBPACK FOOTER //

};


/** WEBPACK FOOTER **
 ** ./client/app/modules/products/components/material-pricing/templates/posters-banners-roll-ups/index.js
 **/